import { render } from "./ProductTypes.vue?vue&type=template&id=5c74161e&scoped=true"
import script from "./ProductTypes.vue?vue&type=script&lang=js"
export * from "./ProductTypes.vue?vue&type=script&lang=js"

import "./ProductTypes.vue?vue&type=style&index=0&id=5c74161e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c74161e"]])

export default __exports__